export const AccountSettingsBaseRouteUrl = '/account-settings';
export var AccountUpgradeType;
(function (AccountUpgradeType) {
    AccountUpgradeType["PAYMENT"] = "UPGRADE_WITH_PAYMENT";
    AccountUpgradeType["ACTIVATION_CODE"] = "UPGRADE_WITH_ACTIVATION_CODE";
})(AccountUpgradeType || (AccountUpgradeType = {}));
export var ListType;
(function (ListType) {
    ListType["CHECKBOX"] = "CHECKBOX_LIST";
    ListType["RADIO"] = "RADIO_LIST";
})(ListType || (ListType = {}));
export var CodeStatus;
(function (CodeStatus) {
    CodeStatus["OK"] = "OK";
    CodeStatus["NOT_FOUND"] = "NOT_FOUND";
    CodeStatus["EXPIRED"] = "EXPIRED";
    CodeStatus["USED"] = "USED";
})(CodeStatus || (CodeStatus = {}));
export var BillingCycleUnit;
(function (BillingCycleUnit) {
    BillingCycleUnit["DAY"] = "DAY";
    BillingCycleUnit["MONTH"] = "MONTH";
})(BillingCycleUnit || (BillingCycleUnit = {}));
export const ACTIVATION_CODE_LENGTH = 24;
export const partsOfPlanTypes = [
    'Free',
    'Pro',
    'Premium',
    'Lite',
    'SMS',
    'Start',
];
